import { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { ShoppingCart } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip';
import { GibletInputArea } from './GibletInputArea';
import { NotificationBell } from '../NotificationBell';
import { EngageAction } from './GibletEngageMenu';
import { toast } from 'sonner';

interface NavbarGibletChatBarProps {
  connectedKBsCount?: number;
  maxKBs?: number;
}

export const NavbarGibletChatBar = ({ connectedKBsCount = 0, maxKBs = 50 }: NavbarGibletChatBarProps) => {
  const [value, setValue] = useState('');
  const navigate = useNavigate();
  const location = useLocation();

  const handleSend = () => {
    if (!value.trim()) return;
    // Navigate to /creators with the message
    navigate('/creators', { state: { initialMessage: value } });
    setValue('');
  };

  const handleEngageAction = (action: EngageAction) => {
    // Consume navigates directly to the marketplace without opening Giblet Chat
    if (action === 'consume') {
      navigate('/ispai-solutions');
      return;
    }
    // All other actions navigate to /creators and trigger the action there
    navigate('/creators', { state: { engageAction: action } });
  };

  const leftExtraButtons = (
    <Tooltip>
      <TooltipTrigger asChild>
        <Button
          onClick={() => navigate("/ispai-solutions")}
          size="icon"
          className="h-7 w-7 bg-green-700 hover:bg-green-700 text-white rounded-full"
          aria-label="Go to Marketplace"
        >
          <ShoppingCart className="h-3.5 w-3.5" />
        </Button>
      </TooltipTrigger>
      <TooltipContent>
        <p>Go to the Marketplace</p>
      </TooltipContent>
    </Tooltip>
  );

  const extraButtons = (
    <NotificationBell compact />
  );

  return (
    <div className="flex-1 max-w-2xl mx-4">
      <GibletInputArea
        value={value}
        onChange={setValue}
        onSend={handleSend}
        onEngageAction={handleEngageAction}
        isLoading={false}
        connectedKBsCount={connectedKBsCount}
        maxKBs={maxKBs}
        variant="bar"
        extraButtons={extraButtons}
        leftExtraButtons={leftExtraButtons}
      />
    </div>
  );
};
